module.exports = __webpack_public_path__ + "assets/img/YCSC-5.87218551.jpg";